export default __webpack_public_path__ + "/dist/images/membership-active.d1fdd186b9cd40b17925abb1e407f2bb.svg";